/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/
import React,{useState,useEffect} from 'react'
import '../css/content.css';
import MultipartAPI from '../Objects/MultipartAPI';
import {
    useNavigate,
    useParams
  } from "react-router-dom";
import '../css/upcomming.css';
import { mdiCloudDownload } from '@mdi/js';
import { mdiVideoPlus } from '@mdi/js';
import { mdiFolderPlay } from '@mdi/js';
import Icon from "@mdi/react";
import { mdiMovieEdit } from '@mdi/js';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import alertinstance from '../Objects/Alert';
import customalertinstance from '../Objects/CustomAlert';
const static_url = process.env.REACT_APP_CDN_STATIC;
const Addcontentmodule = ({icon}) => {

 //initialize contentId for updating content
 const [contentId,setcontentId]=useState('');
 const [contentName,setcontentName]=useState('');
 const [len,setlen]=useState(0)
 const [sidelen,setsidelen]=useState(0)
 const [moovilen,setmoovilen]=useState(0)
 const [page,setpage]=useState(1);
 const [sidepage,setsidepage]=useState(1);
 const [moovipage,setmoovipage]=useState(1);
 const [container, setcontainer] = useState([])
 const [sidecontainer, setsidecontainer] = useState([])
 const [moovicontainer,setmoovicontainer]=useState([])
const [handler,sethandler]=useState([])
const [sidehandler,setsidehandler]=useState([])
const [moovihandler,setmoovihandler]=useState([])
const [startindex,setstartindex]=useState(0)
const [endindex,setendindex]=useState(10)
    //for navigation of pages
    let navigate = useNavigate();
    const [hide,sethide]=useState(false)
    const [listnew,setlistnew]=useState([]);
    const [awsStaticResourcePath, setAwsStaticResourcePath] = useState('')
    const [raw,setRaw]=useState([])
    //for multiple value fetch using single async select tag

    //api call for listing existing content from database
    useEffect(()=>{
        MultipartAPI.get('/listContents')
        .then(res=>{
            const rev = res.data.data.reverse()
            transform(rev)
            setRaw(rev)
          }).catch(err=>{
            if(err.response.status === 403){
              localStorage.clear()
              navigate('/login/error?message=session token expired please login again !')
            }
          })
       },[])

      const DeleteContent =async (contentId)=>{
        let res= {data:{error:false}}
        let re = await customalertinstance(res)
        if(re){
          MultipartAPI.get(`/deleteContent/${contentId}`)
          .then(res=>{
            alertinstance(res)
            }).catch(err=>{
              if(err.response && err.response.status === 403){
                localStorage.clear()
                navigate('/login/error?message=session token expired please login again !')
              }
            })
        }
      }

    const transform =(data)=>{

        const filtered = data.filter(x=> x.app_type === 'normal');
        //setcontainer(filtered)
        var rem;
        var n = filtered.length
        rem = n % 10;
        if(rem > 0){
          n = n + (10-rem)
        }else{
          n=n-rem
        }
        setlen(n/10)
        sethandler(filtered)
        setcontainer(filtered.slice(startindex,endindex));

        /*for sideloaded contents*/
        const filterednew = data.filter(x=> x.app_type === 'sideloaded');
        //setcontainer(filtered)
        var srem;
        var sn = filterednew.length
        srem = sn % 10;
        if(srem > 0){
          sn = sn + (10-srem)
        }else{
          sn=sn-srem
        }
        setsidelen(sn/10)
        setsidehandler(filterednew)
        setsidecontainer(filterednew.slice(startindex,endindex));

          /*for moovi contents*/
          const filteredmoovi= data.filter(x=> x.app_type === 'moovi');
          //setcontainer(filtered)
          var mrem;
          var mn = filteredmoovi.length
          mrem = mn % 10;
          if(mrem > 0){
            mn = mn + (10-mrem)
          }else{
            mn=mn-mrem
          }
          setmoovilen(mn/10)
          setmoovihandler(filteredmoovi)
          setmoovicontainer(filteredmoovi.slice(startindex,endindex));

      }
    const [hover,sethover]=useState(false);

      const checkcontent=(contentId,contentName,categoryName,awsStaticResourcePath)=>{
        if(categoryName === 'Movies'){
            sethide(!hide)
            sethover(hover)
            setcontentId(contentId)
            setcontentName(contentName)
            setAwsStaticResourcePath(awsStaticResourcePath)
        }else{
            sethide(hide)
            sethover(!hover)
            setcontentId(contentId)
            setcontentName(contentName)
            setAwsStaticResourcePath(awsStaticResourcePath)
        }
      }

      const handleChange=(e,value)=>{
        setpage(value)
        if(value === 1){
          const dd  = handler.slice(0,10)
          setcontainer(dd)
        }else{
          const dd1  = handler.slice(value*10 - 10 , value*10)
          setcontainer(dd1)
        }
      }
      const sidehandleChange=(e,value)=>{
        setsidepage(value)
        if(value === 1){
          const dd  = sidehandler.slice(0,10)
          setsidecontainer(dd)
        }else{
          const dd1  = sidehandler.slice(value*10 - 10 , value*10)
          setsidecontainer(dd1)
        }
      }
      const moovihandleChange=(e,value)=>{
        setmoovipage(value)
        if(value === 1){
          const dd  = moovihandler.slice(0,10)
          setmoovicontainer(dd)
        }else{
          const dd1  = moovihandler.slice(value*10 - 10 , value*10)
          setmoovicontainer(dd1)
        }
      }
      const handleSearch=(e)=>{
        let key = e.target.value;
        var filData  = raw.filter(x=>{
          if(x.title.toUpperCase().includes(key.toUpperCase())){
            return x
          }
        })

        if(key.length > 0){
          transform(filData)
        }else if(key.length === 0){
          transform(raw)
        }
      }
    return (
        <div className="content">
        <div className="alert alert-primary">  <i className="fa fa-bars" onClick={icon}></i>
                <span className='leftpush'>All Contents</span>
        </div>
          <p className='path p-3 mt-2'>Home / Contents / </p>
            <button className='btn btn-danger mt-2 mb-2'  onClick={()=>{navigate("/content/add")}}><i className="fa fa-plus"></i> Add content</button>
            <div className='search_div'>
              <input type='text'
              className='form-control mt-2 mb-2'
              placeholder="Search Content Name Here*"
              onChange={handleSearch}/>
            </div>
            {/*for listing content  */}


            <div className={hover ? 'list shadow':'listnone shadow'}>
            <li onClick={()=>{navigate("/seasons/"+`${contentName}`+'/'+`${contentId}`+'/'+`${awsStaticResourcePath}`)}}>
                <Icon path={mdiFolderPlay} title="Dog"  className="mdicon" />  <span>View Seasons</span></li><br/>
                <li onClick={()=>{navigate("/content/update/"+`${contentId}`+'/'+`${contentName}`)}}>
                <Icon path={mdiMovieEdit} title="Dog"  className="mdicon" /> <span>Update Content</span></li>
                <li onClick={() => DeleteContent(contentId)}>
                <Icon path={mdiMovieEdit} title="Dog"  className="mdicon" /> <span>Delete Content</span></li>
            </div>
            <div className={hide ? 'list shadow':'listnone shadow'}>
            <li onClick={()=>{navigate('/videos/'+`${contentId}`+'/'+`${contentName}`)}} >
            <Icon path={mdiFolderPlay} title="Dog"  className="mdicon" /> <span>View Videos</span></li><br/>
            <li onClick={()=>{navigate('/videos/add/'+`${contentId}`+'/'+`${contentName}`)}} >
            <Icon path={mdiVideoPlus} title="Dog"  className="mdicon" />  <span>Add Video</span></li><br/>
            <li onClick={()=>{navigate("/content/update/"+`${contentId}`+'/'+`${contentName}`)}}>
            <Icon path={mdiMovieEdit} title="Dog"  className="mdicon" /> <span>Update Content</span></li><br/>
            <li onClick={()=>{navigate('/download/videos/'+`${contentId}`+'/'+`${contentName}`)}}>
            <Icon path={mdiCloudDownload} className="mdicon"  title="Dog" /> <span>View downloaded Videos</span></li>
            </div>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Normal Contents</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Sideloaded Contents</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="moovi-tab" data-bs-toggle="tab" data-bs-target="#moovi" type="button" role="tab" aria-controls="moovi" aria-selected="false">Moovi Contents</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                {/*normal Contents mapping */}
                <table className="table table-striped mt-2">
                <thead>
                    <tr>
                    <th scope="col">No.</th>
                    <th scope="col">Thumbnail</th>
                    <th scope="col">Name</th>
                    <th scope="col">Category</th>
                    <th scope="col">Director</th>
                    <th scope="col">Release Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"> Option</th>
                    </tr>
                </thead>
                <tbody>
            {container.map((q,index)=>{
                            return(
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td><img style={{'width':'320px' , 'height':'200px'}} src={ static_url +'/' +q.awsStaticResourcePath+'/'+q.landscapePosterIdNormal}/>
                                                <br/>
                                                <p>views - {q.statitics.map(x => { return (<>{x.numViews}</>)})}</p>
                                                </td>
                                                <td>{q.title}</td>
                                                <td>{q.categoryName}</td>
                                                <td>{q.director}</td>
                                                <td>{q.releaseDate}</td>
                                                <td id="status">{q.published ? <span><i class="fa fa-check success"></i> Published</span> :
                                                <span><i className="fa fa-exclamation failure"></i>Unpublished</span>}</td>
                                                <td>
                                                <i className="fa fa-ellipsis-h ms-4"
                                                onClick={() => checkcontent(q._id,q.title,q.categoryName,q.awsStaticResourcePath)}></i>
                                               </td>

                                            </tr>
                                        )

                            })}
                </tbody>
                </table>
                <div className="numbers">
                  <Stack spacing={2}>
                    <Pagination count={len} page={page} onChange={handleChange}  variant="outlined" shape="rounded" />
                  </Stack>
                </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <table className="table table-striped mt-2">
                <thead>
                    <tr>
                    <th scope="col">No.</th>
                    <th scope="col">Thumbnail</th>
                    <th scope="col">Name</th>
                    <th scope="col">Category</th>
                    <th scope="col">Director</th>
                    <th scope="col">Release Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"> Option</th>
                    </tr>
                </thead>
                <tbody>
            {sidecontainer.map((q,index)=>{
                            return(
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td><img style={{'width':'320px' , 'height':'200px'}} src={ static_url +'/' +q.awsStaticResourcePath+'/'+q.landscapePosterIdNormal}/>
                                                <br/>
                                                <p>views - {q.statitics.map(x => { return (<>{x.numViews}</>)})}</p>
                                                </td>
                                                <td>{q.title}</td>
                                                <td>{q.categoryName}</td>
                                                <td>{q.director}</td>
                                                <td>{q.releaseDate}</td>
                                                <td id="status">{q.published ? <span><i class="fa fa-check success"></i> Published</span> :
                                                <span><i className="fa fa-exclamation failure"></i>Unpublished</span>}</td>
                                                <td>
                                                <i className="fa fa-ellipsis-h ms-4"
                                                onClick={() => checkcontent(q._id,q.title,q.categoryName,q.awsStaticResourcePath)}></i>
                                               </td>

                                            </tr>
                                        )

                            })}
                </tbody>
                </table>
                <div className="numbers">
                  <Stack spacing={2}>
                    <Pagination count={sidelen} page={sidepage} onChange={sidehandleChange}  variant="outlined" shape="rounded" />
                  </Stack>
                </div>
            </div>
            {/*moovi*/}
            <div class="tab-pane fade" id="moovi" role="tabpanel" aria-labelledby="moovi-tab">
                <table className="table table-striped mt-2">
                <thead>
                    <tr>
                    <th scope="col">No.</th>
                    <th scope="col">Thumbnail</th>
                    <th scope="col">Name</th>
                    <th scope="col">Category</th>
                    <th scope="col">Director</th>
                    <th scope="col">Release Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"> Option</th>
                    </tr>
                </thead>
                <tbody>
            {moovicontainer.map((q,index)=>{
                            return(
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td><img style={{'width':'320px' , 'height':'200px'}} src={ static_url +'/' +q.awsStaticResourcePath+'/'+q.landscapePosterIdNormal}/>
                                                <br/>
                                                <p>views - {q.statitics.map(x => { return (<>{x.numViews}</>)})}</p>
                                                </td>
                                                <td>{q.title}</td>
                                                <td>{q.categoryName}</td>
                                                <td>{q.director}</td>
                                                <td>{q.releaseDate}</td>
                                                <td id="status">{q.published ? <span><i class="fa fa-check success"></i> Published</span> :
                                                <span><i className="fa fa-exclamation failure"></i>Unpublished</span>}</td>
                                                <td>
                                                <i className="fa fa-ellipsis-h ms-4"
                                                onClick={() => checkcontent(q._id,q.title,q.categoryName,q.awsStaticResourcePath)}></i>
                                               </td>

                                            </tr>
                                        )

                            })}
                </tbody>
                </table>
                <div className="numbers">
                  <Stack spacing={2}>
                    <Pagination count={moovilen} page={moovipage} onChange={moovihandleChange}  variant="outlined" shape="rounded" />
                  </Stack>
                </div>
            </div>
          </div>
        </div>
    )
}

export default Addcontentmodule
